export class Colors {
    public static grid = '0x000000';
    public static viewBorder = '0x555555';
    public static viewBackground = '0xD9D2BF';
    public static appBackground = '0x999999';
    public static blue = '0x0000FF';
    public static red = '0xFF0000';
}
